import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VAppBar,{attrs:{"dark":"","height":"80"}},[_c('div',{staticClass:"w-full d-flex align-center justify-space-between"},[_c('div',{staticClass:"d-flex align-center"},[_c(VIcon,{staticClass:"mr-6 pa-2 highlight",attrs:{"disabled":!_setup.validConfig,"large":""},on:{"click":function($event){return _setup.getRouter.push('/')}}},[_vm._v(" mdi-arrow-left-bold ")]),_c(VToolbarTitle,{staticClass:"text-h4"},[_vm._v("Configuration")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }